import widget from './modules/widget';
import progress from './modules/progress';
export default {
  namespaced: true,
  state: {
    widgetTypes: [
      'CLODOP',
      'CN',
      'PDD',
      'JD',
      'FXG',
      'KM',
      'VIPMP',
      'KS',
      'THH',
      //  'KMBT'
    ],
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    widget,
    progress,
  },
};
